import timeout from '../../utils/timeout';

function baseState() {
    return {
        clearTimeoutId: 0,
        componentName: '',
        header: '',
        body: '',
        text: '',
        footer: '',
        bodyComponentProps: {},
        dialogProps: {},
        type: '',
        listeners: {},
        ok: () => { },
        cancel: () => { },
        okText: 'OK',
        okIcon: '',
        okStyles: {},
        cancelText: 'Cancel',
        cancelIcon: '',
        headerIcon: '',
        critical: false,
        loading: false,
        disableTransitions: false,
        typeToConfirm: '',
    }
}

export default {
    namespaced: true,
    state: baseState(),
    getters: {
        type(state) {
            return state.type;
        },
        componentName(state) {
            return state.componentName;
        },
        header(state) {
            return state.header;
        },
        body(state) {
            return state.body;
        },
        text(state) {
            return state.text;
        },
        bodyComponentProps(state) {
            return state.bodyComponentProps;
        },
        listeners(state) {
            return state.listeners;
        },
        dialogProps(state) {
            return state.dialogProps;
        },
        footer(state) {
            return state.footer;
        },
        ok(state) {
            return state.ok;
        },
        cancel(state) {
            return state.cancel;
        },
        okText(state, getters, rootState, rootGetters) {
            if (state.okText !== 'OK') return state.okText;
            return rootGetters['lang/tr'].ok;
        },
        okIcon(state) {
            return state.okIcon;
        },
        okStyles(state) {
            return state.okStyles;
        },
        cancelText(state, getters, rootState, rootGetters) {
            if (state.cancelText !== 'Cancel') return state.cancelText;
            return rootGetters['lang/tr'].cancel;
        },
        cancelIcon(state) {
            return state.cancelIcon;
        },
        headerIcon(state) {
            return state.headerIcon;
        },
        critical(state) {
            return state.critical;
        },
        loading(state) {
            return state.loading;
        },
        disableTransitions(state) {
            return state.disableTransitions;
        },
        typeToConfirm(state) {
            return state.typeToConfirm;
        },
    },
    mutations: {
        set(state, params) {
            if (params.componentName) {
                state.componentName = params.componentName
                if (params.bodyComponentProps !== undefined) state.bodyComponentProps = params.bodyComponentProps;
            } else {
                state.body = params.body;
            }
            if (params.header) state.header = params.header;
            if (params.text) state.text = params.text;
            if (params.footer) state.footer = params.footer;
            if (params.ok) state.ok = params.ok;
            if (params.cancel) state.cancel = params.cancel;
            if (params.okText) state.okText = params.okText;
            if (params.okIcon) state.okIcon = params.okIcon;
            if (params.okStyles) state.okStyles = params.okStyles;
            if (params.cancelText) state.cancelText = params.cancelText;
            if (params.cancelIcon) state.cancelIcon = params.cancelIcon;
            if (params.headerIcon) state.headerIcon = params.headerIcon;
            if (params.listeners !== undefined) state.listeners = params.listeners;
            if (params.dialogProps !== undefined) state.dialogProps = params.dialogProps;
            if (params.critical !== undefined) state.critical = params.critical;
            if (params.typeToConfirm) state.typeToConfirm = params.typeToConfirm;

            state.type = params.type || 'alert';
        },
        clear(state) {
            let bs = baseState();
            delete bs.disableTransitions;

            for (let key in bs) {
                state[key] = bs[key];
            }
        },
        clearType(state) {
            state.type = '';
        },
        clearTimeoutId(state, clearTimeoutId) {
            state.clearTimeoutId = clearTimeoutId;
        },
        loading(state, loading) {
            state.loading = loading;
        },
        dialogProps(state, props) {
            for (let key in props) {
                state.dialogProps[key] = props[key];
            }
        },
        disableTransitions(state, disable) {
            state.disableTransitions = disable;
        }
    },
    actions: {
        async set({ getters, commit, state }, params) {
            const promise = new Promise(res => {
                const ok = params.ok;
                params.ok = (val = true) => {
                    if (ok) ok(val);
                    res(val);
                }

                const cancel = params.cancel;
                params.cancel = (val = false) => {
                    if (cancel) cancel(val);
                    res(val);
                }
            });

            clearTimeout(state.clearTimeoutId);

            // disable transitions if there's an existing dialog open and we're just changing it
            let disableTransitions = !!getters.type;

            if(disableTransitions) {
                commit('disableTransitions', true);
                await timeout();
            }

            commit('clear');
            commit('set', params);

            if(disableTransitions) {
                await timeout();
                commit('disableTransitions', false);
            }

            return promise;
        },
        async clear({ commit, state }) {
            clearTimeout(state.clearTimeoutId);
            commit('clearType');

            return new Promise(res => {
                let id = setTimeout(function() {
                    commit('clear');
                    res();
                }, 300);
                commit('clearTimeoutId', id);
            });
        },
        emit({ getters }, { name, payload }) {
            if (Object.keys(getters.listeners).includes(name)) {
                getters.listeners[name](payload);
            }
        }
    }
}